import { PATH } from '../constants/path';
import { DEFAULT_LOCALE } from '../constants/locale';

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*String} defaultLocale: default locale of project
 * @param {*Boolean} isCodePromo : codepromo directory ?
 * @param {*Boolean} isOffline : offline directory ?
 * @param {*Boolean} isEbon : ebon directory ?
 * @param {*Boolean} isAllOffers : all offers directory (/cashback/categorie/...) ?
 */
export const buildPathPrefixWithDefaultLocale = (
    locale,
    isCodePromo,
    isOffline,
    isEbon,
    isAllOffers
) =>
    ''.concat(
        locale && locale !== DEFAULT_LOCALE ? `/${locale}` : '',
        isAllOffers
            ? PATH.CASHBACK_PATH
            : isCodePromo
            ? PATH.REDUCTION_PATH
            : isOffline
            ? PATH.CASHBACK_OFFLINE
            : isEbon
            ? PATH.CASHBACK_EBON
            : PATH.CASHBACK_ONLINE
    );

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*Boolean} isCodePromo : codepromo directory ?.
 * @param {*Boolean} isOffline : offline directory ?
 * @param {*Boolean} isEbon : ebon directory ?
 * @param {*Boolean} isAllOffers : all offers directory (/cashback/categorie/...) ?
 */
export const buildPathPrefix = (locale, isCodePromo, isOffline, isEbon, isAllOffers) =>
    buildPathPrefixWithDefaultLocale(locale, isCodePromo, isOffline, isEbon, isAllOffers);



// WEBPACK FOOTER //
// ./src/utils/directoryUtils.js